import React, { useContext } from 'react'
import { FreeAgencyContext } from '../../Context'
import { Box } from '../../Components/Layout'
import { Desc, Head2 } from '../../Components/Typography/Text.styles'
import { Con } from '../../Components/Layout/Containers/ConStyles'
import { FeedWrappedList } from '../../Components/Feed/FeedWrappedList'

export const FreeAgencyNews: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { news } = useContext(FreeAgencyContext)!
  return (
    <Box noMargin>
      {news.length > 0 ? (
        <FeedWrappedList feedItems={news} section="Free Agency" />
      ) : (
        <Con justify="center" direction="column">
          <Head2 justify="center">No News Yet</Head2>
          <Desc justify="center">
            News around Free Agency will show up here as it releases
          </Desc>
        </Con>
      )}
    </Box>
  )
}
